<template>
<div style="height:100%;overflow:hidden;"> 
    <iframe style="width:100%;height:90%;border:none" src='static/html/release-logs.2.5.5.html'></iframe>
   
</div>
   <!-- <div class="notice">
        <h1 class="n-title">更新日志</h1>
        <div class="n-content">
            <h2 class="n-title1" style="font-size:24px;font-weight:bold;">V2.5.4(2018-12-5)</h2>
            <p class="n-content1">-1.增加了常见问题和推荐设备的说明；</p>
            <p class="n-content1">-2.优化了训练介绍画面和结束画面的内容展示；</p>
            <p class="n-content1">-3.临时下架量表《进食评估问卷调查工具-10》，预计下个版本恢复；</p>
            <p class="n-content1">-4.优化了部分训练的名称，具体如下：</p>
            <div class="n-img">
                <table>
                    <tr>
                        <th>原名称</th>
                        <th>新名称</th>
                    </tr>
                    <tr>
                        <td>数字筛选-I</td>
                        <td>数字筛选</td>
                    </tr>
                    <tr>
                        <td>数字筛选-II</td>
                        <td>数字筛选•进阶</td>
                    </tr>
                    <tr>
                        <td>记忆犹新	</td>
                        <td>成双成对•进阶</td>
                    </tr>
                    <tr>
                        <td>藏猫猫棋-II	</td>
                        <td>萍踪浪迹 </td>
                    </tr>
                    <tr>
                        <td>举棋不定	</td>
                        <td>藏猫猫棋•进阶</td>
                    </tr>
                    <tr>
                        <td>举棋不定-II	</td>
                        <td>萍踪浪迹•进阶 </td>
                    </tr>
                    <tr>
                        <td>似曾相识-II	</td>
                        <td>似曾相识•进阶</td>
                    </tr>
                    <tr>
                        <td>似曾相识-III	</td>
                        <td>识物辨价</td>
                    </tr>
                    <tr>
                        <td>鱼翔浅底-反	</td>
                        <td>鱼翔浅底•进阶</td>
                    </tr>
                    <tr>
                        <td>梦想天空-反	</td>
                        <td>梦想天空•进阶</td>
                    </tr>
                    <tr>
                        <td>今天去哪	</td>
                        <td>路在何方</td>
                    </tr>
                    <tr>
                        <td>麻将求和	</td>
                        <td>麻将求和•进阶</td>
                    </tr>
                    <tr>
                        <td>麻将求和-II	</td>
                        <td>麻将求和</td>
                    </tr>
                    <tr>
                        <td>求和比较	</td>
                        <td>麻将比较•进阶</td>
                    </tr>
                    <tr>
                        <td>求和比较-II	</td>
                        <td>麻将比较</td>
                    </tr>
                    <tr>
                        <td>求和比较-III	</td>
                        <td>扑克比较</td>
                    </tr>
                    <tr>
                        <td>打地鼠-II</td>
                        <td>打怪物</td>
                    </tr>
                    <tr>
                        <td>注意记忆	</td>
                        <td>稍纵即逝</td>
                    </tr>
                    <tr>
                        <td>注意记忆-II	</td>
                        <td>稍纵即逝•进阶</td>
                    </tr>
                    <tr>
                        <td>目不暇接-I	</td>
                        <td>目不暇接</td>
                    </tr>
                    <tr>
                        <td>目不暇接-II	</td>
                        <td>目不暇接•进阶</td>
                    </tr>
                    <tr>
                        <td>找大圆	</td>
                        <td>明察秋毫</td>
                    </tr>
                    <tr>
                        <td>判断方向	</td>
                        <td>变幻方向</td>
                    </tr>
                    <tr>
                        <td>幻色图形-II	</td>
                        <td>幻色图字</td>
                    </tr>
                    <tr>
                        <td>幻色气球-II	</td>
                        <td>幻色气球</td>
                    </tr>
                    <tr>
                        <td>缤纷树叶-II	</td>
                        <td>缤纷树叶</td>
                    </tr>
                    <tr>
                        <td>变幻方向	</td>
                        <td>变幻方向•进阶</td>
                    </tr>
                    <tr>
                        <td>迎面而来-II	</td>
                        <td>鸟兽虫鱼</td>
                    </tr>
                    <tr>
                        <td>迎面而来-III	</td>
                        <td>果园飘香</td>
                    </tr>
                    <tr>
                        <td>迎面而来-IV	</td>
                        <td>工具速配</td>
                    </tr>
                    <tr>
                        <td>卡片队列-I	</td>
                        <td>卡片队列</td>
                    </tr>
                    <tr>
                        <td>卡片队列-II	</td>
                        <td>迎面而来•进阶</td>
                    </tr>
                    <tr>
                        <td>卡片队列-III	</td>
                        <td>鸟兽虫鱼•进阶</td>
                    </tr>
                    <tr>
                        <td>卡片队列-IV	</td>
                        <td>果园飘香•进阶</td>
                    </tr>
                    <tr>
                        <td>念念不忘	</td>
                        <td>按图索骥</td>
                    </tr>
                </table>
            </div>

            <h2 class="n-title1" style="font-size:24px;font-weight:bold;">V2.5.3(2018-10-9)</h2>
            <p class="n-content1">-1.提升了系统的稳定性；</p>

            <h2 class="n-title1">V2.5.2.29(2018-07-19)</h2>
            <p class="n-content1">-1.增加脑能力模块，展示训练后的脑力情况；</p>
            <div class="n-img">
                <img src="../../../assets/img/noticeimg3.png" alt="">
            </div>
            <p class="n-content1">-2.医生端新增重置患者密码功能；</p>
            <p class="n-content1">-3.增加在线客服，方便联系我们；</p>
            <p class="n-content1">-4.患者端训练记录页面优化，展示更多训练信息；</p>
            <p class="n-content1">-5.图片命名任务按照素材拆解为2个新任务：图片命名（高频）、图片命名（低频）；</p>
            <p class="n-content1">-6.新增更新日志功能，可以查阅各次更新的内容；</p>
            <p class="n-content1">-7.其他功能优化。</p>

             <h2 class="n-title1">V2.5.2(2018-07-19)</h2>
            <p class="n-content1">-1.增加脑能力模块，展示训练后的脑力情况；</p>
            <p class="n-content1">-2.医生端新增重置患者密码功能；</p>
            <p class="n-content1">-3.增加在线客服，方便联系我们；</p>
            <p class="n-content1">-4.训练记录页面优化，展示更多训练和专业信息；</p>
            <p class="n-content1">-5.图片命名任务按照素材拆解为2个新任务：图片命名（高频）、图片命名（低频）；</p>
            <p class="n-content1">-6.新增更新日志功能，可以查阅各次更新的内容；</p>
            <p class="n-content1">-7.新增科室管理，更方便的管理机构的科室；</p>
            <p class="n-content1">-8.其他细节完善。</p> 
            
            <h2 class="n-title1">v2.5.1（2018-05-29）</h2>
            <p class="n-content1">-1.新增加61个言语训练；</p>
            <p class="n-content1">-2.患者端增加可选训练。患者的今日训练除了推荐训练还可以根据脑能力进行针对性训练；</p>
            <div class="n-img">
                <img src="../../../assets/img/noticeimg.png" alt="">
            </div>
            <p class="n-content1">-3.患者端支持购买居家康复服务；</p>
            <p class="n-content1">-4.增加言语训练“听词指图”和“图片命名”的素材；</p>
            <p class="n-content1">-5.现场训练和现场测评弹窗优化；</p>
            <p class="n-content1">-6.其他细节完善。</p>

            <h2 class="n-title1">v2.4.0（2018-04-12）</h2>
            <p class="n-content1">-1.医生端新增首页，展示常用模块内容；</p>
            <p class="n-content1">-2.现场训练时，医生可以调整认知类训练的初始难度和训练时长；</p>
            <div class="n-img">
                <img src="../../../assets/img/noticeimg2.png" alt="">
            </div>
            <p class="n-content1">-3.言语训练支持暂停，并优化了4个训练的样式；</p>
            <p class="n-content1">-4.量表中图片点击后支持放大和打印；</p>
            <p class="n-content1">-5.患者端登录支持记住密码；</p>
            <p class="n-content1">-6.优化了其他细节。</p>
        </div>
        <div class="n-footer">
            <button @click="goHome()">关闭</button>
        </div>
    </div>-->
</template>

<script>
    export default ({
        data() {
            return {

            }
        },
        methods: {
            // goHome(){
            //     // this.$parent.$parent.toRefresh();
            //     // this.$parent.$parent.dialog=false;
            //     window.close();
            // }
        }
    })
</script>
<style scoped>
.notice{
margin:0 30px;
}
.n-title{
text-align:center;
}
.n-content{
font-size:16px;
}
.n-footer{
text-align: center;
}
.n-footer button{
background-color:#333;
}
n-img,.n-img img{
width:400px;
}
.n-img table{
width:400px;
border:1px solid #ccc;
text-align:center;
overflow: hidden;
}
table tr{
border-bottom:1px solid #ccc;
}
table tr th,table tr td{
border-right:1px solid #ccc;
}
@media (-webkit-max-width: 1280px) and (-webkit-min-width: 1024px),(max-width:1280px) and (min-width:1024px){
.notice{
width:600px;
height:500px;
}
.n-title{
margin-top:0px;
font-size: 20px;
}
.n-title1{
font-size: 18px;
}
.n-content1{
font-size: 14px;
}
n-img,.n-img img{
background-size:100%; 
width:272px;
height: 158px;
}
}
@media (-webkit-max-width: 1024px),(max-width:1024px){
.notice{
width:600px;
height:500px;
}
.n-title{
margin-top:0px;
font-size: 20px;
}
.n-title1{
margin:8px 0 8px 0;
font-size: 16px;
}
.n-content1{
font-size: 14px;
}
n-img,.n-img img{
width:272px;
height: 158px;
}
}
</style>




// WEBPACK FOOTER //
// seeLog.vue?22b3ea48